import { render, staticRenderFns } from "./ProjectsDetailMeta.vue?vue&type=template&id=2d29ceb4&"
import script from "./ProjectsDetailMeta.vue?vue&type=script&lang=js&"
export * from "./ProjectsDetailMeta.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsDetailMeta.vue?vue&type=style&index=0&id=2d29ceb4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports